import { render } from "./DonutChartNarrow.vue?vue&type=template&id=ea076416"
import script from "./DonutChartNarrow.vue?vue&type=script&lang=js"
export * from "./DonutChartNarrow.vue?vue&type=script&lang=js"
script.render = render

export default script